import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import WarningTriangleIcon from "@medoma/components/icons/WarningTriangleIcon";
import styles from "./WarningChip.module.scss";

const WarningChip = ({
  children,
  size = "medium",
}: Pick<Parameters<typeof Chip>[0], "size" | "children">) => {
  return (
    <CustomProperties className={styles.warning}>
      <Chip
        iconStart={<WarningTriangleIcon />}
        border="solid"
        background="solid"
        shape="sharp"
        size={size}
      >
        {children}
      </Chip>
    </CustomProperties>
  );
};

export default WarningChip;
